import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

/**
 * Standard modal header for Finance dialogs — title icon + title + close X.
 * Slots into the top of every finance dialog (Import Data, Filter by, Edit
 * Resource, Copy to, etc.) so the chrome stays consistent.
 *
 * Standalone so it can be imported directly by consuming components without
 * a module declaration. Emits {@code closed} on the X button; the host dialog
 * wires that to {@code MatDialogRef.close()}. Named "closed" (past tense)
 * rather than "close" so it doesn't shadow the standard DOM "close" event
 * (typescript:S7651).
 */
@Component({
  selector: 'app-finance-modal-header',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './finance-modal-header.component.html',
  styleUrl: './finance-modal-header.component.scss',
})
export class FinanceModalHeaderComponent {
  /** Material icon name shown next to the title. Optional. */
  @Input() icon?: string;
  /** Visible heading text. */
  @Input() title = '';
  /** Override the close button's aria-label (e.g. "Close filters"). Defaults to "Close". */
  @Input() closeAriaLabel = 'Close';

  @Output() closed = new EventEmitter<void>();

  onClose(): void {
    this.closed.emit();
  }
}
